import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { Modal } from "react-bootstrap";
import Footer from "../../components/Footer";
import { Link } from "react-router-dom";
import Carousel from "react-bootstrap/Carousel";
import Accordion from "react-bootstrap/Accordion";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./RelationshipCoaching.css";
import loader from '../../assests/loader.gif';
import API from '../../Utils/Api';


const RelationshipCoaching = () => {
  const [loading,setLoading] = useState(true);
  const [show, setShow] = useState(false);

  const navigate = useNavigate();

  const [femalecoach, setFemalecoach] = useState({id:'',name:'',description:'',image:''});
  const [malecoach, setMalecoach] = useState({id:'',name:'',description:'',image:''});
  const [femalecourse, setFemalecourse] = useState([]);
  const [malecourse, setMalecourse] = useState([]);
  
  const [trailerid, setTrailerid] = useState('');
  const [traileridmo, setTraileridmo] = useState('');
  const [cid, setCid] = useState(0);


  useEffect(() => {
    document.title = `Dating Masterclasses | Get Relationship Ready`;
    document.getElementById('bodywrap').className = 'brand';

    localStorage.removeItem("prev_page");
    localStorage.removeItem("checkout_data");
    const metaDesc = document.querySelector("meta[name='description']");
      if (metaDesc) {
        metaDesc.setAttribute("content", "Learn to navigate modern dating with confidence and clarity. Our expert-led masterclasses include video guidance, a downloadable worksheet and practical tools to help you communicate better, understand what you want and build real, meaningful connections.");
      }

    /* Start get coach data */
    API.get('get_coach')
      .then(response => {
        setLoading(false);
      if(response.data.status === false){
        
      }else{
         setFemalecourse(response.data.data.female_course);
         setMalecourse(response.data.data.male_course);
         setFemalecoach({
            id:response.data.data.coach[0].id,
            name:response.data.data.coach[0].name,
            description:response.data.data.coach[0].description,
            image:response.data.data.coach[0].image,
         });
         setMalecoach({
            id:response.data.data.coach[1].id,
            name:response.data.data.coach[1].name,
            description:response.data.data.coach[1].description,
            image:response.data.data.coach[1].image,
         });
      }                  
    }).catch(error => {
       setLoading(false);
    });  
   /* End get coach data */
  }, []);

  const setShowtrailerid = (trailer_id,mobile_course_trailer,id) => {
      setTrailerid(trailer_id);
      setTraileridmo(mobile_course_trailer);
      setCid(id);
      setShow(true);
  }

  return (
    <>
      <Header isMasterClass={true} />
      <div className="hello-worldss d-flex position-relative justify-content-center align-items-center">
        {/* Desktop Image */}
        <img
          src={process.env.REACT_APP_BASE_URL + 'assests/images/relation-new.jpeg'}
          alt=""
          className="img-fluid omagu123"
        />
        <div className="overlay-text-omag position-absolute dat-overlay-text text-center">
        <h1 className="mb-2 text-uppercase">Dating <br /> Masterclass</h1>
        <p className="mb-0">SERIES</p>
      </div>
            {/*<div className="overlay-text-omag dat-overlay-img position-absolute text-center">
            <img
              src={process.env.REACT_APP_BASE_URL + 'assests/images/Dating-Masterclass-Series.png'}
              alt=""
              className="img-fluid "
            />
          </div>*/}
      </div>

      <div className="container-fluid ireland" style={{ background: "#FBF9F4" }}>
        <div className="row g-4">
          <div className="col-md-6 ire-left">
            <p>Relationship Coaching </p>
            <h2 className="mb-0">Get Relationship Ready</h2>
            {/*<h2 className="mt-0">Ready</h2>*/}
          </div>

          <div className="col-md-6 ire-right">
            <p className="mb-0">
              Our <b>Dating Masterclasses</b> are designed to help singles navigate modern dating with greater confidence and self-awareness. Whether you're working on communication, understanding what you truly want in a partner, or just getting comfortable putting yourself out there, each session offers expert-led video content, a downloadable worksheet, and practical tools to help you build stronger, more meaningful connections.
            </p>
          </div>
        </div>
      </div>

      <div className="container-fluid expand" style={{ background: "#F1E9DF" }}>
        <div className="row align-items-strech d-flex">
          {/* Left Side Content */}
          <div className="col-md-5 d-flex flex-column justify-content-between">
            <div className="tired">
              <h2>HOW IT WORKS</h2>
              <h4>What to expect</h4>
              <p>Each masterclass is designed to give you clear, actionable guidance from a qualified expert. You'll receive everything you need to reflect, reset, and take confident steps forward in your dating life.</p>
            </div>
          </div>

          <div className="col-md-1"></div>

          {/* Right Side Features */}
          <div className="col-md-6 d-flex flex-column">
            <div className="d-flex flex-grow-1 gap-3 locat upma">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/brand-51.png'}
                alt="Previous"
                className="img-fluid w-auto h-auto"
              />
              <div>
                <h5>Professional Guidance</h5>
                <p className="mb-0">
                  15-20 minute expert led video from one of our qualified coaches.
                </p>
              </div>
            </div>
           
            <div className="d-flex flex-grow-1 gap-3 locat upma">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/brand-53.png'}
                alt="Previous"
                className="img-fluid w-auto h-auto"
              />
              <div>
                <h5>A downloadable worksheet</h5>
                <p className="mb-0">
                  with key takeaways and reflection prompts
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat upma">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/brand-54.png'}
                alt="Previous"
                className="img-fluid w-auto h-auto ms-2"
              />
              <div>
                <h5>Unlimited access to your masterclass</h5>
                <p className="mb-0">
                  watch anytime on desktop or mobile
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat locats upma">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/brand-55.png'}
                alt="Previous"
                className="img-fluid w-auto h-auto"
              />
              <div>
                <h5>Practical tools you can start using today</h5>
                <p className="mb-0">
                  to improve your dating life
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
     
      <div className="container-fluid owned pb-5">
        <div className="get-miss poi thumak">
          <div className="row d-flex align-items-strech g-4">
            {/* Text Section */}
            <div className="col-md-4 od-2 d-flex order-2 order-md-1">
              <div className="get-app opra d-flex flex-column flex-grow-1 horiz">
                <div className="tired">
                  <h2>MEET THE COACH</h2>
                  <h4>{femalecoach.name}</h4>
                </div>
                <div className="tired-2 mt-auto">
                  <p className="mb-0 text-start">
                    {femalecoach.description}
                  </p>
                </div>
              </div>
            </div>

            {/* Image Section */}
            <div className="col-md-8 od-1 d-flex order-1 order-md-2">
              <img
                src={femalecoach.image}
                alt="Event Promo"
                className="img-fluid eve-img"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid discover up-even disroveru pt-0 lo-oma">
        <div className="d-none d-md-flex row">
         {femalecourse.map((val, i) => ( 
          <div className="col-md-4 mb-4 joker pocho">
            <div className="card vesi h-100 d-flex flex-column">
              <Link
                to=""
                className="text-decoration-none"
              >
                <img
                  src={val.image}
                  className="card-img-top"
                  alt=""
                />
              </Link>
              <div className="card-body d-flex flex-column">
                <h5><img src={process.env.REACT_APP_BASE_URL + 'assests/images/bubble-frame.png'} className="img-fluid w-auto h-auto" alt="" style={{ width: "14px", minHeight: "22px", marginRight: "10px" }} />Suggested for Ladies</h5>
                <p>{val.name}</p>

                <div className="mt-auto d-flex gap-2 flex-wrap juma purch-his">
                  <button className="sec-fra w-100 text-center" onClick={() => setShowtrailerid(val.trailer_video_url,val.mobile_course_trailer_url,val.id)}>
                    Watch trailer
                  </button>
                  <button className="btn w-100 mt-0" onClick={() => navigate(`/master-class-video/${val.id}`)}>
                    View masterclass
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
        </div>

        <div className="d-block d-md-none">
          <Carousel className="p-0">
            {femalecourse.map((val, i) => ( 
            <Carousel.Item className="px-2 joker pocho">
              <div className="card">
                <Link
                  to=""
                  className="text-decoration-none"
                >
                  <img
                    src={val.image}
                    className="card-img-top"
                    alt=""
                  />
                </Link>
                <div className="card-body nanu">
                  <Link
                    to=""
                    className="text-decoration-none"
                  >
                    <h5><img src={process.env.REACT_APP_BASE_URL + 'assests/images/bubble-frame.png'} className="img-fluid w-auto h-auto" alt="" style={{ width: "14px", minHeight: "22px", marginRight: "10px" }} />Suggested for Ladies</h5>
                  </Link>
                  <p>{val.name}</p>

                  <div className="d-flex gap-2 flex-wrap juma purch-his">
                    <button className="sec-fra mt-0 w-100 text-center" onClick={() => setShowtrailerid(val.trailer_video_url,val.mobile_course_trailer_url,val.id)}>
                      Watch trailer
                    </button>
                    <button className="btn w-100 mt-0" onClick={() => navigate(`/master-class-video/${val.id}`)}>
                      View masterclass
                    </button>
                  </div>
                </div>
              </div>
            </Carousel.Item>
           ))}
          </Carousel>
        </div>

        <div className="text-center mt-4">
          <button className="btn" onClick={() => navigate(`/coaching-video/${femalecoach.id}`)}>
            VIEW ANNIE'S MASTERCASS SET
          </button>
        </div>
      </div>

      <div className="container-fluid owned pb-5">
        <div className="get-miss poi thak">
          <div className="row d-flex align-items-strech g-4">

            {/* Image Section */}
            <div className="col-md-8 od-2 d-flex">
              <img
                src={malecoach.image}
                alt="Event Promo"
                className="img-fluid eve-img"
              />
            </div>

            {/* Text Section */}
            <div className="col-md-4 od-1 d-flex">
              <div className="get-app opra d-flex flex-column flex-grow-1 horiz">
                <div className="tired">
                  <h2>MEET THE COACH</h2>
                  <h4>{malecoach.name}</h4>
                </div>
                <div className="tired-2 mt-auto">
                  <p className="mb-0 text-start">
                    {malecoach.description}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid discover up-even disroveru pt-0 lo-oma">
        <div className="d-block d-md-none">
          <Carousel className="p-0">
            {malecourse.map((val, i) => ( 
            <Carousel.Item className="px-2 joker pocho">
              <div className="card">
                <Link
                  to=""
                  className="text-decoration-none"
                >
                  <img
                    src={val.image}
                    className="card-img-top"
                    alt=""
                  />
                </Link>
                <div className="card-body nanu">
                  <Link
                    to=""
                    className="text-decoration-none"
                  >
                    <h5><img src={process.env.REACT_APP_BASE_URL + 'assests/images/bubble-frame-men.png'} className="img-fluid w-auto h-auto" alt="" style={{ width: "14px", minHeight: "22px", marginRight: "10px" }} />Suggested for Men</h5>
                  </Link>
                  <p>The principles, habits, and standards that create real progress</p>

                  <div className="d-flex gap-2 flex-wrap juma purch-his">
                    <button className="sec-fra mt-0 w-100 text-center" onClick={() => setShowtrailerid(val.trailer_video_url,val.mobile_course_trailer_url,val.id)}>
                      Watch trailer
                    </button>
                    <button className="btn w-100 mt-0" onClick={() => navigate(`/master-class-video/${val.id}`)}>
                      View masterclass 
                    </button>
                  </div>
                </div>
              </div>
            </Carousel.Item>
            ))}
            
          </Carousel>
        </div>
        
        <div className="d-flex row">
          {malecourse.map((val, i) => ( 
          <div className="col-md-4 mb-4 joker pocho d-none d-md-flex">
            <div className="card vesi h-100 d-flex flex-column">
              <Link
                to=""
                className="text-decoration-none"
              >
                <img
                  src={val.image}
                  className="card-img-top"
                  alt=""
                />
              </Link>
              <div className="card-body nanu d-flex flex-column">
                <h5><img src={process.env.REACT_APP_BASE_URL + 'assests/images/bubble-frame-men.png'} className="img-fluid w-auto h-auto" alt="" style={{ width: "14px", minHeight: "22px", marginRight: "10px" }} />Suggested for Men</h5>
                <p>{val.name} </p>

                <div className="mt-auto purch-his koi">
                  <Link to="" className="sec-fra w-100 text-center" onClick={() => setShowtrailerid(val.trailer_video_url,val.mobile_course_trailer_url,val.id)}>
                    <div className="masterclass">Watch trailer</div>
                  </Link>
                  <button className="btn w-100 mt-0" onClick={() => navigate(`/master-class-video/${val.id}`)}>
                    View masterclass
                  </button>
                </div>
              </div>
            </div>
          </div>
          ))}


          <div className="col-md-4 mb-4 joker pocho order-2 order-md-3 d-md-flex ms-auto">
            <div className="od-2 get-miss pt-0 h-100">
              <div className="get-app mura jomu h-100 d-flex flex-column flex-grow-1 horiz justify-content-between">
                <div className="tired fora">
                  <h2>81<span>%</span></h2>
                  <h4>of men say improving their mindset and habits helped them become better partners.</h4>
                </div>
                <div className="tired-2">
                  <p className="mb-0 text-start">
                    Modern Masculinity Report, 2023
                  </p>
                </div>
              </div>
            </div>
          </div>


          <div className="col-12 mb-5 text-center mt-sm-4 mt-5 d-block d-md-none order-1">
            <button className="btn" onClick={() => navigate(`/coaching-video/${malecoach.id}`)}>
              VIEW BRIAN'S MASTERCASS SET
            </button>
          </div>
        </div>

        <div className="text-center mt-0 mt-sm-4 d-none d-md-block">
          <button className="btn" onClick={() => navigate(`/coaching-video/${malecoach.id}`)}>
            VIEW BRIAN'S MASTERCASS SET
          </button>
        </div>
      </div>

      <div className="conainer-fluid accors oikj">
        <div className="row">
          <div className="col-md-6">
            <h2>FAQ</h2>
            <h3>Good to know</h3>
          </div>
          <div className="col-md-6">
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  What are these masterclasses about?
                </Accordion.Header>
                <Accordion.Body>
                  They are practical, psychology informed sessions that help you understand patterns,
                  build self trust, and adopt habits that support healthy relationships. We have sourced
                  leading experts in the field, with dedicated videos tailored for women and separate
                  videos tailored for men.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  Who are they for?
                </Accordion.Header>
                <Accordion.Body>
                  Smart, growth-minded people who are ready to do the work and become the best
                  version of themselves to attract a great partner. The content is tailored, with
                  dedicated videos for women and separate videos for men.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  How long is each masterclass?
                </Accordion.Header>
                <Accordion.Body>
                  Each video runs 14 to 20 minutes and is dense with practical tools. We recommend
                  rewatching to cement the learning, and you will also get a one page PDF summary
                  of key points to keep you accountable.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  Are the classes live or recorded?
                </Accordion.Header>
                <Accordion.Body>
                  Our masterclasses are recorded so you can watch in your own time.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>
                  How long do I have access to the masterclass?
                </Accordion.Header>
                <Accordion.Body>
                  Lifetime access to the recordings and any included worksheets for personal use.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5">
                <Accordion.Header>
                  Are there worksheets or exercises?
                </Accordion.Header>
                <Accordion.Body>
                  Yes. Each class includes a one page PDF summary of key points to keep you accountable.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="6">
                <Accordion.Header>
                  Is this therapy?
                </Accordion.Header>
                <Accordion.Body>
                  No. It is educational coaching content. It can sit alongside therapy if you choose.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="7">
                <Accordion.Header>
                  What results can I expect?
                </Accordion.Header>
                <Accordion.Body>
                  You will understand your patterns, have clear tools to change them, and a step by step plan to practise. Results depend on consistent application.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="8">
                <Accordion.Header>
                  Can I buy the masterclasses as a bundle?
                </Accordion.Header>
                <Accordion.Body>
                  Yes, you can choose to purchase the classes individually or as a bundle.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="9">
                <Accordion.Header>
                  Do you offer refunds?
                </Accordion.Header>
                <Accordion.Body>
                  Masterclasses are non refundable once purchased. You receive lifetime on demand
                  access to the video and the one page PDF via your account so you can rewatch
                  anytime. If you have a technical issue or made a duplicate purchase by mistake,
                  email hello@yourfriendmyfriend.ie within 7 days and we will help resolve it.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="10" className="hololast">
                <Accordion.Header>Is my information private?</Accordion.Header>
                <Accordion.Body>
                  Yes. Your purchase details and viewing data are kept confidential and never shared with others.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
      <Modal show={show} onHide={() => setShow(false)} centered size="lg" dialogClassName="custom-modal-nyt">
             <Modal.Header closeButton>Why modern women feel disconnected in love — and how to come home to yourself</Modal.Header>
              <Modal.Body className="text-center">
                <div className="position-relative mb-4">
                  <iframe
                    title="YouTube video player"
                  src={trailerid}
                 allow="fullscreen; encrypted-media"
                  allowFullScreen
                style={{
                border: 'none',
                borderRadius: '15px'
              }}
              className="pop-youtube-video d-none d-md-block"
                ></iframe>
                  <iframe
                    title="YouTube video player"
                  src={traileridmo}
                 allow="fullscreen; encrypted-media"
                  allowFullScreen
                style={{
                border: 'none',
                borderRadius: '15px'
              }}
              className="pop-youtube-video d-block d-md-none"
                ></iframe>
                  {/*<video
                    src={process.env.REACT_APP_BASE_URL + 'assests/videos/masterclass-preview.mp4'}
                    poster={process.env.REACT_APP_BASE_URL + 'assests/images/blaru.png'}
                    className="w-100" 
                    playsInline
                    muted
                    autoPlay
                    loop
                  ></video>
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/pause-icon.png'} 
                    alt="Play"
                    className="position-absolute top-50 start-50 translate-middle"
                    style={{ cursor: "pointer", borderRadius: "0", height: "auto" }}
                  />*/}
                </div>

                <div className="d-flex justify-content-center gap-2 flex-wrap juma purch-his">
                  <button className="btn budha mt-0" onClick={() => navigate(`/master-class-video/${cid}`)}>
                    get masterclass
                  </button>
                </div>
              </Modal.Body>
            </Modal>
      {loading && (
     <div className="loadingClass">
      <img src={loader} alt="loader"/>
    </div>
     )}
      <Footer />
    </>
  );
};

export default RelationshipCoaching;
